import React, { useState, useEffect } from 'react';
import styles from './styles.module.css';
import Slider from '@components/slider';

const Module = ({ title, text }) => {
  return (
    <>
      <div className={styles.module}>
        <h6 className={styles.courseTitle}>{title}</h6>
        <ul className={styles.list}>
          {text.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      </div>
    </>
  );
};

const Program = ({ program }) => {
  const size = useWindowSize().width;
  function useWindowSize() {
    const isClient = typeof window === 'object';

    function getSize() {
      return {
        width: isClient ? window.innerWidth : undefined,
        height: isClient ? window.innerHeight : undefined
      };
    }

    const [windowSize, setWindowSize] = useState(getSize);

    useEffect(() => {
      if (!isClient) {
        return false;
      }

      function handleResize() {
        setWindowSize(getSize());
      }

      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowSize;
  }
  return (
    <>
      <div className={styles.slider}>
        <h4 className={styles.title}>Куррикулум</h4>
        <Slider
          slidesToShow={size > 767 ? 2.4 : 1.5}
          slidesToScroll={size > 767 ? 3 : 1}
        >
          {program.map((item, i) => (
            <div key={i} className={styles.slide}>
              <Module title={item.title} text={item.text} />
            </div>
          ))}
        </Slider>
      </div>
    </>
  );
};

export default Program;
